<template>
  <div>
    <v-row>
      <v-col cols="12" md="12"
        ><h2>Erstattung bei laufender Behandlung</h2>
        Zahnzusatzversicherungen leisten für alle neu eingetretenen Behandlungen
        / Diagnosen nach Vertragsabschluss. Bereits angeratene oder laufende
        Behandlungen sind grundsätzlich vom Versicherungsschutz ausgeschlossen.
        <b>Hinweis:</b> bei einigen Versicherungen können laufende Behandlungen
        gegen einen Aufpreis mitversichert werden.
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";

  const props = defineProps({
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });
  console.log(props.tarif);
</script>
